import HTTPService from './service';

const service = new HTTPService();

export default service;
